// extracted by mini-css-extract-plugin
module.exports = {"bird":"_1FQamV","button":"_2k4B7B","shine-lines":"SnH2aO"};